import { Component, Input, OnInit, AfterViewInit, ElementRef } from '@angular/core';

/// Tooltip component for displaying contextual information
/// Usage: Place <app-tooltip selector=".tooltip-target">Tooltip Content</app-tooltip> within a container having attribute 'iptooltipcontainer'.
/// The 'selector' input specifies the CSS selector for elements that will trigger the tooltip on click or hover.
@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss'
})
export class TooltipComponent implements OnInit, AfterViewInit {
  @Input() selector = '';
  private timeoutId: any;
  private globalClickBound = false;
  constructor(private elRef: ElementRef) { }
  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
      const tooltipTriggerList: HTMLElement[] = Array.from(this.elRef.nativeElement.closest('[iptooltipcontainer]').querySelectorAll(this.selector));
      tooltipTriggerList.forEach(tooltipTriggerEl => {
        tooltipTriggerEl.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          const tooltip = this.elRef.nativeElement.children[0].classList.add('show-tooltip');
          if (!this.globalClickBound) {
            window.addEventListener('click', this.hideTooltipGlobal.bind(this), { once: true });
            this.globalClickBound = true;
          }
        });
        tooltipTriggerEl.addEventListener('mouseenter', () => {
          const tooltip = this.elRef.nativeElement.children[0].classList.add('show-tooltip');          
          clearTimeout(this.timeoutId);
        });
        tooltipTriggerEl.addEventListener('mouseleave', () => {          
          this.timeoutId = setTimeout(() => {
            const tooltip = this.elRef.nativeElement.children[0].classList.remove('show-tooltip');
          }, 500);
        });
      });
   }
  

   hideTooltipGlobal() {
     const tooltip = this.elRef.nativeElement.children[0].classList.remove('show-tooltip');
     this.globalClickBound = false
   }
}

